import { render, staticRenderFns } from "./MapPoint.vue?vue&type=template&id=8ad56096&scoped=true&"
import script from "./MapPoint.vue?vue&type=script&lang=js&"
export * from "./MapPoint.vue?vue&type=script&lang=js&"
import style0 from "./MapPoint.vue?vue&type=style&index=0&id=8ad56096&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad56096",
  null
  
)

export default component.exports